// ReduxPaymentSlice.js
import { createSlice } from "@reduxjs/toolkit";

const ReduxPaymentSlice = createSlice({
  name: "payments",
  initialState: {
    paymentList: [],
    totalAmount: 0,
  },
  reducers: {
    addPayment: (state, action) => {
      state.paymentList.push(action.payload);
      state.totalAmount += parseFloat(action.payload.cardamount) || 0;
    },
    deletePayment: (state, action) => {
      const removedPayment = state.paymentList.splice(action.payload, 1)[0];
      state.totalAmount -= parseFloat(removedPayment.cardamount) || 0;
    },
    resetPayments: (state) => {
      state.paymentList = [];
      state.totalAmount = 0;
    },
  },
});

export const { addPayment, deletePayment, resetPayments } =
  ReduxPaymentSlice.actions;
export default ReduxPaymentSlice.reducer;
